export class Site {
  public siteId: number;
  public stateId: number;
  public cityId: number;
  public companyId: number;
  public name: string;
  public hq: boolean;
  public addressId: number;
}
